import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  drawer: {
    maxWidth: '100%',
  },
  header: {
    background: '#eceff1',
    color: '#333e58',
    padding: 16,
    fontWeight: 600,
    fontSize: 18,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  container: {
    overflowX: 'hidden',
    maxWidth: 500,
    [theme.breakpoints.down('sm')]: {
      maxWidth: '100%',
    },
  },
  clickable: {
    padding: 16,
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    fontSize: 16,
  },
  clickableButton: { marginLeft: 16 },
  back: {
    padding: '16px 16px 0px 16px',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
  },
  containerHint: {
    fontSize: 14,
    padding: 16,
  },
  button: {
    background: '#ffffff',
  },
  title: {
    color: '#0d47a1',
    fontWeight: 600,
    fontSize: 16,
    marginBottom: 16,
  },
}));

export default useStyles;
